<template>

  <v-container fluid class="px-0 mt-0 page page-user-item">

    <!-- Page Content -->
    <v-container fluid>
      <transition name="fade-flash" mode="out-in">
        <router-view />
      </transition>
    </v-container>

  </v-container>

</template>

<script>
export default {
  name: 'UserRootPage',

  data () {
    return {
      isDataLoading: false,
      user: null
    }
  },

  props: {
    userId: {
      type: String,
      required: true
    }
  },

  async beforeMount () {
    // Load user
    this.isDataLoading = true
    this.loadUser()
    this.isDataLoading = false
  },

  methods: {
    async loadUser () {
      this.user = await this.$store.dispatch('sh/dataApi', {
        method: 'get',
        uri: `user/${this.userId}`
      })
    }
  }
}
</script>

<style scoped>
</style>
